module.exports = __webpack_public_path__ + "img/fixed.23992408.png";